import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>
					That Prior Authorization number has been cancelled.
				</p>
			</div>
		);
	}
}